import React, { useEffect, useState, useContext } from "react";
import Constants from "../constants/Constants";
import AllConversations from "./AllConversations";
import { useTheme } from "../context/theme.context";
import SitesContext from "../context/sites.context";
import UserContext from "../context/users.context";
import { navigate } from "@reach/router";
import { Link } from "@reach/router";
const DM = ({ dispatch }) => {
  const [messages, setMessages] = useState([]);
  const [viewConvo, setViewContent] = useState(0);
  const [pickingModel, setPickingModel] = useState(false);
  const allModels = useContext(SitesContext);
  const user = useContext(UserContext);
  const themeState = useTheme();
  useEffect(() => {
    fetch(`${Constants.API}get-my-messages.php`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        setMessages(res);
        dispatch({ type: "mailchecked", payload: null });
      });
  }, [dispatch]);

  return (
    <div className="dmMain">
      {!pickingModel ? (
        <>
          <div className="wrapper_field">
            <div className="headline_panel">
              <h2 className="title profile">
                <Link to={`${Constants.MA}profile`}>Profile</Link>
              </h2>
              {viewConvo === 0 ? (
                <h2 className="title profile active">Messages</h2>
              ) : (
                <h2 className="title profile" onClick={() => setViewContent(0)}>
                  Messages
                </h2>
              )}
              <i className="icon-moon" onClick={themeState.toggle} />
              <a href="https://addfriends.com/reset/">
                <i className="icon-exit" />
              </a>
            </div>
          </div>
          <AllConversations
            messages={messages}
            setViewContent={setViewContent}
            dispatch={dispatch}
          />
        </>
      ) : null}

      {!pickingModel ? (
        <div className="startDM">
          <button className="startDMBTN" onClick={() => setPickingModel(true)}>
            <i className="icon-message"></i> Start chat
          </button>
        </div>
      ) : (
        <div className="pickingFriend">
          <h2>Pick Friend To DM</h2>
          <div className="modelImages">
            <div
              className="friendAvatar"
              key={`dmf9`}
              onClick={() => {
                navigate(`${Constants.MA}messages/9`);
              }}
            >
              <img
                src={`https://static.addfriends.com/images/support.jpg`}
                alt=""
              />
            </div>
            {user.map((sub) => {
              return (
                <div
                  className="friendAvatar"
                  key={`dmf${sub.siteid}`}
                  onClick={() => {
                    navigate(`${Constants.MA}messages/${sub.siteid}`);
                  }}
                >
                  <img
                    src={`https://static.addfriends.com/images/${
                      allModels[sub.siteid].site_url
                    }.jpg`}
                    alt=""
                  />
                </div>
              );
            })}
          </div>
          <div className="closeCentered">
            <i className="icon-close" onClick={() => setPickingModel(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DM;
